@if (url() && target()) {
  @if (isPathRelativeWithSelfTarget()) {
    <a
      class="no-underline h-full block cta-link"
      [routerLink]="urlForRelativePath()"
      [queryParams]="queryParams()"
      [fragment]="anchor()"
      [target]="target()">
      <ng-container [ngTemplateOutlet]="template()"></ng-container>
    </a>
  } @else {
    <a class="no-underline h-full block cta-link" [href]="url()" [target]="target()">
      <ng-container [ngTemplateOutlet]="template()"></ng-container>
    </a>
  }
} @else {
  <ng-container [ngTemplateOutlet]="template()"></ng-container>
}
